export default __webpack_public_path__ + "static/media/webMockupCaract.c5d2f588.jpg";